// src/views/Clientes/Estaciones/ListarEstaciones.jsx
import React, { useEffect, useState } from "react";
import {FaEye,FaEdit,FaExclamationCircle,FaExclamationTriangle} from "react-icons/fa";

import useEscClose from "../../useEscClose";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import FiltroEess from "./FiltroEess";
import VerEess from "./VerEess";
import EditarEstacion from "./EditarEstacion";
import InactivarPinesPlayero from "./InactivarPinesPlayero";
import InactivarPinesMaestro from "./InactivarPinesMaestro";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

// ============================
const DEFAULT_PAGE_SIZE = 30;

// ============================
// COMPONENTE
// ============================
export default function ListarEstaciones() {
  // ============================
  //         LISTADO
  // ============================
  const [items, setItems] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [porPagina, setPorPagina] = useState(DEFAULT_PAGE_SIZE);
  const [totalBackend, setTotalBackend] = useState(0);
  const [cargando, setCargando] = useState(false);

  // ============================
  //         MODALES
  // ============================
  const [showVisualizar, setShowVisualizar] = useState(false);
  const [idVisualizar, setIdVisualizar] = useState(null);
  useEscClose(() => setShowVisualizar(false), showVisualizar);

  const [showEditar, setShowEditar] = useState(false);
  const [idEditar, setIdEditar] = useState(null);
  useEscClose(() => setShowEditar(false), showEditar);

  const [showInactivarPlayeros, setShowInactivarPlayeros] = useState(false);
  const [estacionInactivarPlayeros, setEstacionInactivarPlayeros] =useState(null);
  useEscClose(() => {
    setShowInactivarPlayeros(false);
    setEstacionInactivarPlayeros(null);
  }, showInactivarPlayeros);

  const [showInactivarMaestros, setShowInactivarMaestros] = useState(false);
  const [estacionInactivarMaestros, setEstacionInactivarMaestros] =useState(null);
  useEscClose(() => {
    setShowInactivarMaestros(false);
    setEstacionInactivarMaestros(null);
  }, showInactivarMaestros);

  // ============================
  //         FILTROS
  // ============================
  const [filtros, setFiltros] = useState({});
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  useEscClose(() => setMostrarFiltros(false), mostrarFiltros);

  const limpiarSeleccion = () => {
    const empty = {};
    setFiltros(empty);
    setPaginaActual(1);
    fetchEstaciones(0, porPagina, empty);
  };

  // ============================
  //         FETCH REAL
  // ============================
  const fetchEstaciones = async (
    pageIndex = paginaActual - 1,
    size = porPagina,
    filtrosAplicados = filtros
  ) => {
    setCargando(true);
    try {
      const url = apiRoutes.eess.listUrl({
        page: pageIndex,
        size,

        codigoEstacion: filtrosAplicados.codigoEstacion,
        nombreEstacion: filtrosAplicados.nombreEstacion,

        descricaoDireccion: filtrosAplicados.descricaoDireccion,
        descricaoRuc: filtrosAplicados.descricaoRuc,
        descricaoEmail: filtrosAplicados.descricaoEmail,
        dataAlta: filtrosAplicados.dataAlta,

        zonaId: filtrosAplicados.zona?.id,
      });

      const data = await appFetchJson(url);

      setItems(data.items || []);
      setTotalBackend(data.totalElements || 0);

      // protección de página fuera de rango
      const nuevasPaginas = Math.max(
        1,
        Math.ceil((data.totalElements || 0) / size)
      );
      if (paginaActual > nuevasPaginas) {
        setPaginaActual(nuevasPaginas);
      }
    } catch (err) {
      console.error("Error al cargar estaciones:", err);
      setItems([]);
      setTotalBackend(0);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchEstaciones(0, porPagina, filtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================
  //         PAGINACIÓN
  // ============================
  const totalPaginas = Math.max(
    1,
    Math.ceil((totalBackend || 0) / (porPagina || 1))
  );

  const cambiarPagina = (num) => {
    const pagina = Math.min(Math.max(num, 1), totalPaginas);
    setPaginaActual(pagina);
    fetchEstaciones(pagina - 1, porPagina, filtros);
  };

  // ============================
  //         RENDER
  // ============================

  const renderNumero = (valor) => {
    if (valor === null || valor === undefined) return "";
    return Number(valor).toFixed(1); // o 2 si querés
  };

  return (
    <div className="page">
      <ListHeader
        title="Estaciones"
        onFilterClick={() => setMostrarFiltros(true)}
        filters={filtros}
        onClearFilters={limpiarSeleccion}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPaginaActual(1);
          fetchEstaciones(0, size, filtros);
        }}
      />

      {mostrarFiltros && (
        <FiltroEess
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
            setFiltros(nuevosFiltros);
            setPaginaActual(1);
            setMostrarFiltros(false);
            fetchEstaciones(0, porPagina, nuevosFiltros);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {showVisualizar && idVisualizar && (
        <VerEess
          id={idVisualizar}
          onClose={() => {
            setShowVisualizar(false);
            setIdVisualizar(null);
          }}
        />
      )}

      {showEditar && idEditar && (
        <EditarEstacion
          id={idEditar}
          onClose={() => {
            setShowEditar(false);
            setIdEditar(null);
          }}
          onSaved={() => {
            setShowEditar(false);
            setIdEditar(null);
            fetchEstaciones(paginaActual - 1, porPagina, filtros);
          }}
        />
      )}

      {showInactivarPlayeros && estacionInactivarPlayeros && (
        <InactivarPinesPlayero
          estacion={estacionInactivarPlayeros}
          onClose={() => {
            setShowInactivarPlayeros(false);
            setEstacionInactivarPlayeros(null);
          }}
          onSaved={() => {
            setShowInactivarPlayeros(false);
            setEstacionInactivarPlayeros(null);
            fetchEstaciones(paginaActual - 1, porPagina, filtros);
          }}
        />
      )}

      {showInactivarMaestros && estacionInactivarMaestros && (
        <InactivarPinesMaestro
          estacion={estacionInactivarMaestros}
          onClose={() => {
            setShowInactivarMaestros(false);
            setEstacionInactivarMaestros(null);
          }}
          onSaved={() => {
            setShowInactivarMaestros(false);
            setEstacionInactivarMaestros(null);
            fetchEstaciones(paginaActual - 1, porPagina, filtros);
          }}
        />
      )}

      {/* TABLA */}
      <div className="overflow-x-auto mt-4">
        <table className="table-card table-sm">
          <thead className="table-head">
            <tr>
              <th className="cell text-left">Cod. EE.SS.</th>
              <th className="cell text-left">EE.SS.</th>
              {/* NUEVA COLUMNA ESTADO AQUÍ */}
              <th className="cell text-center">Estado</th>
              <th className="cell text-right">Flete</th>
              <th className="cell text-right">% Alquiler</th>
              <th className="cell-center">Acción</th>
            </tr>
          </thead>

          <tbody>
            {cargando ? (
              <tr>
                {/* colSpan ajustado de 5 a 6 */}
                <td colSpan={6} className="cell text-center">
                  Cargando…
                </td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                {/* colSpan ajustado de 5 a 6 */}
                <td colSpan={6} className="cell text-center">
                  Sin resultados
                </td>
              </tr>
            ) : (
              items.map((row, i) => (
                <tr key={row.id} className={i % 2 === 0 ? "row-alt" : ""}>
                  <td className="cell">{row.codigoEstacion}</td>
                  <td className="cell">{row.nombreEstacion}</td>
                  
                  {/* NUEVA COLUMNA DE DATOS ESTADO AQUÍ */}
                  <td className="cell text-center">
                    {row.eessFlota === "SI" ? (
                      <span className="font-bold text-green-600">EESS Activa</span>
                    ) : row.eessFlota === "NO" ? (
                      <span className="font-bold text-red-600">EESS Inactiva</span>
                    ) : (
                      <span className="font-bold text-gray-500">-</span>
                    )}
                  </td>

                  <td className="cell text-right">
                    {renderNumero(row.valorFlete)}
                  </td>

                  <td className="cell text-right">
                    {renderNumero(row.porcentajeAlquiler)}
                  </td>

                  <td className="cell-center space-x-2">
                    <button
                      className="icon-btn"
                      title="Visualizar"
                      onClick={() => {
                        setIdVisualizar(row.id);
                        setShowVisualizar(true);
                      }}
                    >
                      <FaEye />
                    </button>

                    <button
                      className="icon-btn"
                      title="Editar"
                      onClick={() => {
                        setIdEditar(row.id);
                        setShowEditar(true);
                      }}
                    >
                      <FaEdit />
                    </button>

                    <button
                      className="icon-btn text-yellow-600"
                      title="Inactivar pines Playeros"
                      onClick={() => {
                        setEstacionInactivarPlayeros(row);
                        setShowInactivarPlayeros(true);
                      }}
                    >
                      <FaExclamationTriangle />
                    </button>

                    <button
                      className="icon-btn text-yellow-600"
                      title="Inactivar pines Maestros"
                      onClick={() => {
                        setEstacionInactivarMaestros(row);
                        setShowInactivarMaestros(true);
                      }}
                    >
                      <FaExclamationCircle />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ListFooter
        page={paginaActual}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={cambiarPagina}
      />
    </div>
  );
}